import faqStyle from './faq.module.css';

export function FAQ() {
  return (
    <div className={faqStyle.div}>Часто спрашивают</div>
  );
}
